import {
  Category,
  toCategory,
  toCategoryPostReqDTO,
  toCategoryPutReqDTO,
} from "../model/category";
import { CategoryGetResDTO } from "./category-dto";
import { getApiClient } from "../../../shared/api/client.api";
import { CommonResponseDto } from "../../../shared/api/common-response.dto";

/**
 * Category API 클라이언트
 * Category 관련 API 호출을 담당
 */
export const manageCategoryApi = (() => {
  const apiClient = getApiClient();

  const getCategoryList = async (): Promise<Category[]> => {
    try {
      const response =
        await apiClient.get<CommonResponseDto<CategoryGetResDTO[]>>(
          "/categories",
        );

      if (!response.data.success || !response.data.data) {
        throw new Error("Category list data not found");
      }

      return response.data.data.map((category: CategoryGetResDTO) =>
        toCategory(category),
      );
    } catch (error) {
      console.error("Failed to fetch category list:", error);
      throw error;
    }
  };

  const getCategory = async (categoryId: string): Promise<Category> => {
    try {
      const response = await apiClient.get<
        CommonResponseDto<CategoryGetResDTO>
      >(`/categories/${categoryId}`);

      if (!response.data.success || !response.data.data) {
        throw new Error("Category data not found");
      }

      return toCategory(response.data.data);
    } catch (error) {
      console.error("Failed to fetch category:", error);
      throw error;
    }
  };

  const addCategory = async (
    category: Omit<Category, "id" | "createdAt" | "updatedAt">,
  ): Promise<CategoryGetResDTO> => {
    try {
      const payload = toCategoryPostReqDTO(category);
      const response = await apiClient.post<
        CommonResponseDto<CategoryGetResDTO>
      >("/categories", payload);

      if (!response.data.success || !response.data.data) {
        throw new Error("Failed to add category");
      }

      return response.data.data;
    } catch (error) {
      console.error("Failed to add category:", error);
      throw error;
    }
  };

  const updateCategory = async (
    categoryId: string,
    category: Partial<Category>,
  ): Promise<CategoryGetResDTO> => {
    try {
      const payload = toCategoryPutReqDTO({ ...category, id: categoryId });
      const response = await apiClient.put<
        CommonResponseDto<CategoryGetResDTO>
      >(`/categories/${categoryId}`, payload);

      if (!response.data.success || !response.data.data) {
        throw new Error("Failed to update category");
      }

      return response.data.data;
    } catch (error) {
      console.error("Failed to update category:", error);
      throw error;
    }
  };

  const deleteCategory = async (categoryId: string): Promise<void> => {
    try {
      await apiClient.delete(`/categories/${categoryId}`);
    } catch (error) {
      console.error("Failed to delete category:", error);
      throw error;
    }
  };

  return {
    getCategoryList,
    getCategory,
    addCategory,
    updateCategory,
    deleteCategory,
  };
})();
